import { $ as e, C as t, F as n, J as r, L as i, S as a, U as o, _ as s, at as c, g as l, h as u, i as d, m as f, ot as p, p as m, q as h, rt as g, s as _, t as v, v as y, w as b } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as x } from "./i18n-lite-BcmwMblk.js";
import { t as S } from "./normalize-props-DNjMoRjC.js";
import { t as C } from "./Button.ce-Dstoud2U.js";
//#region src/webcomponents/pix-anonymisation/locales/de-AT.json
var w = {}, T = {}, E = {}, D = {}, O = {}, k = { "pix-anonymisation": {
	prompt: { title: "Prompt" },
	rephrase: { title: "Reformulation" },
	buttons: {
		checkNow: "Suivant",
		displayRephrasing: "Suivant",
		nextPrompt: "Suivant"
	},
	correction: "élements qui doivent être anonymisés:"
} }, A = {}, j = {}, M = {
	ref: "prompt-container",
	tabindex: "-1"
}, N = { class: "stepper-container" }, P = { key: 0 }, F = { class: "prompt-card" }, I = ["aria-level"], L = { class: "prompt-card-content" }, R = ["for"], z = ["id", "value"], B = { class: "prompt-card-content-part" }, V = { class: "prompt-card" }, H = ["aria-level"], U = { class: "prompt-card-content" }, W = { class: "sr-only" }, G = { class: "sr-only" }, K = {
	key: 0,
	class: "prompt-card rephrase"
}, q = ["aria-level"], J = { class: "prompt-card-content" }, Y = {
	key: 1,
	class: "feedback"
}, X = /*#__PURE__*/ v(/* @__PURE__ */ b({
	__name: "PixAnonymisation.ce",
	props: {
		titleLevel: {
			default: 2,
			type: Number
		},
		steps: { type: Array }
	},
	setup(d, { expose: v }) {
		let b = e(0), x = e([]), S = e(1), w = o("prompt-container"), T = f(() => d.steps[b.value]), E = f(() => S.value === 3 && b.value + 1 === d.steps.length), D = f(() => S.value === 3), O = f(() => T.value.fullSentence.map(({ content: e }) => e)), k = f(() => T.value.fullSentence.map(({ content: e, isAnonymizable: t }) => t ? {
			content: e,
			color: "green"
		} : {
			content: e,
			color: x.value.includes(e) ? "red" : "neutral"
		})), A = f(() => T.value.fullSentence.filter(({ isAnonymizable: e }) => e).map(({ content: e }) => e));
		function j() {
			S.value = 1, b.value = 0, x.value = [];
		}
		function X() {
			if (D.value) {
				S.value = 1, b.value++, x.value = [];
				return;
			}
			S.value++, w.value.focus();
		}
		return v({ reset: j }), (e, o) => (n(), y("div", M, [u("header", null, [u("div", N, [(n(!0), y(m, null, i(d.steps, (e, t) => (n(), y("div", {
			key: t,
			class: g(["stepper-background", {
				"is-active": b.value === t,
				"is-finished": t < b.value
			}]),
			style: c({ "--step-width": `${100 / d.steps.length}%` })
		}, [u("div", {
			class: "progress-bar",
			style: c({ "--progress-bar-width": `${100 / d.steps.length * S.value}%` })
		}, null, 4)], 6))), 128)), u("span", null, p(b.value + 1) + " / " + p(d.steps.length), 1)])]), u("main", null, [S.value === 1 ? (n(), y("form", P, [u("div", F, [u("div", {
			role: "heading",
			class: "prompt-card__heading",
			"aria-level": d.titleLevel
		}, p(e.$t("pix-anonymisation.prompt.title")), 9, I), u("div", L, [(n(!0), y(m, null, i(O.value, (e, t) => (n(), y("label", {
			key: e,
			for: `${e}-${t}`
		}, [r(u("input", {
			id: `${e}-${t}`,
			"onUpdate:modelValue": o[0] ||= (e) => x.value = e,
			value: e,
			class: "sr-only",
			type: "checkbox"
		}, null, 8, z), [[_, x.value]]), u("span", B, p(e), 1)], 8, R))), 128))])]), t(C, {
			"is-disabled": x.value.length === 0,
			onClick: X
		}, {
			default: h(() => [a(p(e.$t("pix-anonymisation.buttons.checkNow")), 1)]),
			_: 1
		}, 8, ["is-disabled"])])) : (n(), y("div", {
			key: 1,
			class: g(["results", { "prompt-and-rephrase": D.value }])
		}, [
			u("div", V, [
				u("div", {
					role: "heading",
					class: "prompt-card__heading",
					"aria-level": d.titleLevel
				}, p(e.$t("pix-anonymisation.prompt.title")), 9, H),
				u("p", U, [(n(!0), y(m, null, i(k.value, ({ content: e, color: t }, r) => (n(), y("span", { key: r }, [u("span", { class: g(["prompt-card-content-part", t]) }, p(e), 3)]))), 128))]),
				u("p", W, p(e.$t("pix-anonymisation.correction")), 1),
				u("ul", G, [(n(!0), y(m, null, i(A.value, (e) => (n(), y("li", { key: e }, p(e), 1))), 128))])
			]),
			D.value ? (n(), y("div", K, [u("div", {
				role: "heading",
				class: "prompt-card__heading",
				"aria-level": d.titleLevel
			}, p(e.$t("pix-anonymisation.rephrase.title")), 9, q), u("p", J, p(T.value.rephrase), 1)])) : s("", !0),
			D.value ? (n(), y("p", Y, p(T.value.feedback), 1)) : s("", !0),
			E.value ? s("", !0) : (n(), l(C, {
				key: 2,
				class: "feedback-button",
				onClick: X
			}, {
				default: h(() => [a(p(D.value ? e.$t("pix-anonymisation.buttons.nextPrompt") : e.$t("pix-anonymisation.buttons.displayRephrasing")), 1)]),
				_: 1
			}))
		], 2))])], 512));
	}
}), [["styles", ["html[data-v-98f0ed02],body[data-v-98f0ed02],div[data-v-98f0ed02],span[data-v-98f0ed02],applet[data-v-98f0ed02],object[data-v-98f0ed02],iframe[data-v-98f0ed02],h1[data-v-98f0ed02],h2[data-v-98f0ed02],h3[data-v-98f0ed02],h4[data-v-98f0ed02],h5[data-v-98f0ed02],h6[data-v-98f0ed02],p[data-v-98f0ed02],blockquote[data-v-98f0ed02],pre[data-v-98f0ed02],a[data-v-98f0ed02],abbr[data-v-98f0ed02],acronym[data-v-98f0ed02],address[data-v-98f0ed02],big[data-v-98f0ed02],cite[data-v-98f0ed02],code[data-v-98f0ed02],del[data-v-98f0ed02],dfn[data-v-98f0ed02],em[data-v-98f0ed02],img[data-v-98f0ed02],ins[data-v-98f0ed02],kbd[data-v-98f0ed02],q[data-v-98f0ed02],s[data-v-98f0ed02],samp[data-v-98f0ed02],small[data-v-98f0ed02],strike[data-v-98f0ed02],strong[data-v-98f0ed02],sub[data-v-98f0ed02],sup[data-v-98f0ed02],tt[data-v-98f0ed02],var[data-v-98f0ed02],b[data-v-98f0ed02],u[data-v-98f0ed02],i[data-v-98f0ed02],center[data-v-98f0ed02],dl[data-v-98f0ed02],dt[data-v-98f0ed02],dd[data-v-98f0ed02],ol[data-v-98f0ed02],ul[data-v-98f0ed02],li[data-v-98f0ed02],fieldset[data-v-98f0ed02],form[data-v-98f0ed02],label[data-v-98f0ed02],legend[data-v-98f0ed02],table[data-v-98f0ed02],caption[data-v-98f0ed02],tbody[data-v-98f0ed02],tfoot[data-v-98f0ed02],thead[data-v-98f0ed02],tr[data-v-98f0ed02],th[data-v-98f0ed02],td[data-v-98f0ed02],article[data-v-98f0ed02],aside[data-v-98f0ed02],canvas[data-v-98f0ed02],details[data-v-98f0ed02],embed[data-v-98f0ed02],figure[data-v-98f0ed02],figcaption[data-v-98f0ed02],footer[data-v-98f0ed02],header[data-v-98f0ed02],hgroup[data-v-98f0ed02],menu[data-v-98f0ed02],nav[data-v-98f0ed02],output[data-v-98f0ed02],ruby[data-v-98f0ed02],section[data-v-98f0ed02],summary[data-v-98f0ed02],time[data-v-98f0ed02],mark[data-v-98f0ed02],audio[data-v-98f0ed02],video[data-v-98f0ed02],dialog[data-v-98f0ed02]{font-size:100%;font:inherit;vertical-align:baseline;border:0;margin:0;padding:0}article[data-v-98f0ed02],aside[data-v-98f0ed02],details[data-v-98f0ed02],figcaption[data-v-98f0ed02],figure[data-v-98f0ed02],footer[data-v-98f0ed02],header[data-v-98f0ed02],hgroup[data-v-98f0ed02],menu[data-v-98f0ed02],nav[data-v-98f0ed02],section[data-v-98f0ed02]{display:block}body[data-v-98f0ed02]{line-height:1}ol[data-v-98f0ed02],ul[data-v-98f0ed02]{list-style:none}table[data-v-98f0ed02]{border-collapse:collapse;border-spacing:0}[data-v-98f0ed02]{color:#122647;box-sizing:border-box;font-style:normal}p[data-v-98f0ed02],label[data-v-98f0ed02],button[data-v-98f0ed02]{font-family:Roboto,sans-serif;font-size:.875rem;font-weight:400}form[data-v-98f0ed02],.results[data-v-98f0ed02]{flex-direction:column;gap:16px;display:flex}button[data-v-98f0ed02]{margin:0 auto;font-weight:700}.heading[data-v-98f0ed02]{text-align:center;font-family:Nunito,Roboto,sans-serif;font-size:1.25rem;font-weight:700}.stepper-container[data-v-98f0ed02]{align-items:center;gap:6px;margin-bottom:16px;display:flex}.stepper-container span[data-v-98f0ed02]{white-space:nowrap;font-size:.875rem}.stepper-background[data-v-98f0ed02]{flex:1 1 var(--step-width);background-color:#e8eaed;border-radius:64px;height:8px}.stepper-background.is-active .progress-bar[data-v-98f0ed02]{height:8px;width:var(--progress-bar-width);background:#613fdd;border-radius:64px}.stepper-background.is-finished[data-v-98f0ed02]{background:#613fdd;border-radius:64px;width:100%;height:8px}.prompt-card[data-v-98f0ed02]{border:1px solid #cdd1d9;border-radius:16px;padding:16px}.prompt-card__heading[data-v-98f0ed02]{margin-bottom:8px;font-family:Roboto,sans-serif;font-size:1rem;font-weight:700}.prompt-card-content[data-v-98f0ed02]{background:#f4f5f7;border-radius:8px;flex-wrap:wrap;gap:4px;padding:16px;display:flex}.prompt-card-content>span[data-v-98f0ed02]{padding:2px}.prompt-card-content-part[data-v-98f0ed02]{border:1px solid #cdd1d9;border-radius:4px;margin-bottom:5px;padding:1px 4px}.prompt-card-content-part.red[data-v-98f0ed02]{background:#e4766f;border-color:#0000}.prompt-card-content-part.green[data-v-98f0ed02]{background:#54c590;border-color:#0000}input:checked~.prompt-card-content-part[data-v-98f0ed02]{background:#ffdc76;border-color:#0000}input:focus~.prompt-card-content-part[data-v-98f0ed02]{outline:1px solid #000}.prompt-and-rephrase[data-v-98f0ed02]{grid-template-columns:1fr 1fr;gap:16px;display:grid}.prompt-and-rephrase .feedback[data-v-98f0ed02]{background:#eaf1ff;border-radius:16px;grid-column:1/span 2;padding:16px}.feedback-button[data-v-98f0ed02]{grid-column:1/span 2}.sr-only[data-v-98f0ed02]{clip-path:inset(50%);border:0;width:1px;height:1px;margin:-1px;padding:0;position:absolute;overflow:hidden}@media screen and (width<=768px){.prompt-card[data-v-98f0ed02]{grid-column:1/span 2;margin-top:8px}.prompt-card.rephrase[data-v-98f0ed02]{margin-top:0}.feedback[data-v-98f0ed02]{margin-block:8px}}"]], ["__scopeId", "data-v-98f0ed02"]]);
//#endregion
//#region src/webcomponents/pix-anonymisation/pix-anonymisation.ce.js
x.addTranslationsFromGlobResults(/* #__PURE__ */ Object.assign({
	"./locales/de-AT.json": w,
	"./locales/en.json": T,
	"./locales/es-419.json": E,
	"./locales/es.json": D,
	"./locales/fr-BE.json": O,
	"./locales/fr.json": k,
	"./locales/it.json": A,
	"./locales/nl.json": j
}));
var Z = d(X, { configureApp(e) {
	x.changeLanguage(document?.documentElement?.lang || navigator.language), e.use(x);
} });
Z.prototype.normalizeProps = (e) => ({
	...e,
	titleLevel: S(e.titleLevel)
}), window.customElements.define("pix-anonymisation", Z);
//#endregion
